import { render } from "./ArrivalTimesAlternative.vue?vue&type=template&id=70bc64c1&scoped=true"
import script from "./ArrivalTimesAlternative.vue?vue&type=script&lang=js"
export * from "./ArrivalTimesAlternative.vue?vue&type=script&lang=js"

import "./ArrivalTimesAlternative.vue?vue&type=style&index=0&id=70bc64c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bc64c1"]])

export default __exports__